import React, { useState, useEffect, useContext } from 'react';
import { Container, Table, Badge } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';

const MyRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        // TODO: Implement API call to fetch user's requests
        setLoading(false);
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <h2 className="mb-4">My Requests</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Request Type</th>
                        <th>Current Step</th>
                        <th>Status</th>
                        <th>Submitted Date</th>
                        <th>Last Updated</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {requests.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center">No requests found</td>
                        </tr>
                    ) : (
                        requests.map(request => (
                            <tr key={request.id}>
                                <td>{request.type}</td>
                                <td>{request.currentStep}</td>
                                <td>
                                    <Badge bg={
                                        request.status === 'Pending' ? 'warning' :
                                        request.status === 'Approved' ? 'success' :
                                        request.status === 'Rejected' ? 'danger' : 'secondary'
                                    }>
                                        {request.status}
                                    </Badge>
                                </td>
                                <td>{new Date(request.submittedDate).toLocaleDateString()}</td>
                                <td>{new Date(request.lastUpdated).toLocaleDateString()}</td>
                                <td>
                                    {/* Add action buttons here */}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </Container>
    );
};

export default MyRequests; 